/// <amd-module name="Widgets/PullRequestsWidget/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\dashboards\widgets\pull-requests-widget-content-new\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve a pull request.
     * 
     * @param pullRequestId - The ID of the pull request to retrieve.
     * @param project - Project ID or project name
     */
    getPullRequestById(pullRequestId: number, project?: string): Promise<Git.GitPullRequest>;
    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param project - Project ID or project name
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    getPullRequestsByProject(project: string, searchCriteria: Git.GitPullRequestSearchCriteria, maxCommentLength?: number, skip?: number, top?: number): Promise<Git.GitPullRequest[]>;
    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param repositoryId - The repository ID of the pull request's target branch.
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param project - Project ID or project name
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    getPullRequests(repositoryId: string, searchCriteria: Git.GitPullRequestSearchCriteria, project?: string, maxCommentLength?: number, skip?: number, top?: number): Promise<Git.GitPullRequest[]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve a pull request.
     * 
     * @param pullRequestId - The ID of the pull request to retrieve.
     * @param project - Project ID or project name
     */
    public async getPullRequestById(
        pullRequestId: number,
        project?: string
        ): Promise<Git.GitPullRequest> {

        return this.beginRequest<Git.GitPullRequest>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/pullRequests/{pullRequestId}",
            routeValues: {
                project: project,
                pullRequestId: pullRequestId
            }
        });
    }

    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param project - Project ID or project name
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    public async getPullRequestsByProject(
        project: string,
        searchCriteria: Git.GitPullRequestSearchCriteria,
        maxCommentLength?: number,
        skip?: number,
        top?: number
        ): Promise<Git.GitPullRequest[]> {

        const queryValues: any = {
            searchCriteria: searchCriteria,
            maxCommentLength: maxCommentLength,
            '$skip': skip,
            '$top': top
        };

        return this.beginRequest<Git.GitPullRequest[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/pullRequests",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param repositoryId - The repository ID of the pull request's target branch.
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param project - Project ID or project name
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    public async getPullRequests(
        repositoryId: string,
        searchCriteria: Git.GitPullRequestSearchCriteria,
        project?: string,
        maxCommentLength?: number,
        skip?: number,
        top?: number
        ): Promise<Git.GitPullRequest[]> {

        const queryValues: any = {
            searchCriteria: searchCriteria,
            maxCommentLength: maxCommentLength,
            '$skip': skip,
            '$top': top
        };

        return this.beginRequest<Git.GitPullRequest[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pullRequests/{pullRequestId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

}

export const GitClientName = "Widgets.PullRequestsWidget.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
